export function createPasswordValidator() {
  function validateTooShort(fieldValue: string) {
    return fieldValue.trim().length >= 15
  }

  function validateMatchesUsername(fieldValue: string, username?: string) {
    const normalizedUsername = username?.trim().toLowerCase()

    if (!normalizedUsername) return false

    return fieldValue.trim().toLowerCase() === normalizedUsername
  }

  function validateContainsReservedTerms(fieldValue: string, reservedTerms: string[]) {
    const normalizedValue = fieldValue.toLowerCase()

    return reservedTerms.some(term => {
      const normalizedTerm = term.trim().toLowerCase()

      return normalizedTerm.length > 0 && normalizedValue.includes(normalizedTerm)
    })
  }

  function validateRepeatedPattern(fieldValue: string) {
    const value = fieldValue.trim()

    if (value.length < 2) return false

    const normalizedValue = value.toLowerCase()

    // the password is a unit repeated, of any length, a partial unit at the end still counts:
    // ex:- aaaaaa, 111111, 121212121212121, abcabcab, passwordpassword
    // the unit has to fit at least twice, so it can be at most half of the password
    const maxCheckedUnitLength = Math.floor(normalizedValue.length / 2)

    for (let unitLength = 1; unitLength <= maxCheckedUnitLength; unitLength++) {
      let repeatsUnit = true

      for (let i = unitLength; i < normalizedValue.length; i++) {
        if (normalizedValue[i] !== normalizedValue[i % unitLength]) {
          repeatsUnit = false
          break
        }
      }

      if (repeatsUnit) return true
    }

    // the whole password is a run of consecutive characters:ex:- 123456789, abcdef, 987654
    const step = normalizedValue.charCodeAt(1) - normalizedValue.charCodeAt(0)

    if (step !== 1 && step !== -1) return false

    for (let i = 2; i < normalizedValue.length; i++) {
      if (normalizedValue.charCodeAt(i) - normalizedValue.charCodeAt(i - 1) !== step) return false
    }

    return true
  }

  return {
    validateTooShort,
    validateMatchesUsername,
    validateContainsReservedTerms,
    validateRepeatedPattern,
  }
}
